import * as type from './types'


export function fetchUploadedFiles(payload) {
    return {
        type: type.FETCH_UPLOADED_FILES,
        payload,
    }
}

export function fetchedUploadedFiles(payload) {
    return {
        type: type.FETCHED_UPLOADED_FILES,
        payload,
    }
}

export function resetUploadedFiles() {
    return {
        type: type.RESET_UPLOADED_FILES,
    }
}
